import comp from "./LeLibrary";
export default comp;
